import { render, staticRenderFns } from "./TicketList.vue?vue&type=template&id=16686278&"
import script from "./TicketList.vue?vue&type=script&lang=js&"
export * from "./TicketList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16686278')) {
      api.createRecord('16686278', component.options)
    } else {
      api.reload('16686278', component.options)
    }
    module.hot.accept("./TicketList.vue?vue&type=template&id=16686278&", function () {
      api.rerender('16686278', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/support/TicketList.vue"
export default component.exports